import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_ALL_WATER_STATIONS } from '../../../../graphql/Catalog/WaterStations/waterstations'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'
import { Link } from 'react-router-dom'
import moment from 'moment'

const WaterStations = () => {
  const [dataTable, setDataTable] = useState([])
  const [count, setCount] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [filters, setFilters] = useState({
    status: null,
  })

  const { loading, error, data } = useQuery(GET_ALL_WATER_STATIONS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error

      const { getAllWaterStations } = data

      const infoWaterStations = getAllWaterStations.rows.map((waterStation) => {
        const splitHours = waterStation?.operating_hours?.split('-') || []

        let startHour = ''
        let endHour = ''

        if (splitHours.length > 1) {
          startHour = moment(splitHours[0].trim(), 'HH:mm').format('HH:mm a')
          endHour = moment(splitHours[1].trim(), 'HH:mm').format('hh:mm a')
        }

        return {
          id: waterStation.id,
          Nombre: waterStation.name,
          Encargado: waterStation.manager,
          Contacto: waterStation.contact_info,
          Dirección: waterStation.address,
          Horario: `${startHour} - ${endHour}`,
        }
      })

      setDataTable(infoWaterStations)
      setCount(getAllWaterStations.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  return (
    <>
      <ContentHeader
        breadcrumb=""
        title="Estaciones de agua"
        windowTitle="Estaciones de agua"
        addNewButton
        addNewButtonText="Agregar estación"
      />
      <LayoutTable
        hideId
        data={dataTable}
        totalCount={count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        title="Lista de estaciones de agua"
        FilterBarPlaceholder="Buscar por descripción"
        hideDetails
        hideAddNew
      />
    </>
  )
}

export default WaterStations
